export default "__VITE_ASSET__DlI8HKo8__"